// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"b82e38f7","478":"ca8975bb","498":"26537962","534":"ef75ed4b","787":"956a3731","839":"855c8bac","964":"7fe1e2d5"}[chunkId] + ".chunk.js";
};